export default __webpack_public_path__ + "static/joe-desktop-ea37628aa54e79035ed9e4f8013fe25d.webp";